import { gql } from '@apollo/client';

export const postArrepentimientoPreSolicitudSP = gql`
mutation  ArrepentimientoPreSolicitudSPApiRQ{
    ArrepentimientoPreSolicitudSPApiRS(input: $input)  
        @rest(type: "ArrepentimientoPreSolicitudSPApiRS", path: "/api/gateway/formularios/Arrepentido", method: "PUT"){
            nroSolicitud
            nroSecuencia
            resultado
            error
            stackTrace
        }
}
`

